import PageLayout from "./PageLayout";
import PageSection from "./PageSection";
import EmptyState from "./EmptyState";
import SkeletonLoader from "./SkeletonLoader";
import { typography } from "../../styles/index";

/**
 * Generic layout for list-based pages
 * (Documents, Shipments, Invoices, Exceptions)
 */
export default function ListPageTemplate({
  title,
  actions,
  actionBar,
  filters,
  loading,
  empty,
  emptyText = "No items found.",
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyActionLabel,
  onEmptyAction,
  emptySecondaryActionLabel,
  onEmptySecondaryAction,
  children,
}) {
  return (
    <PageLayout title={title} actions={actions}>
      {actionBar && <PageSection>{actionBar}</PageSection>}

      {filters && <PageSection>{filters}</PageSection>}

      {loading ? (
        <SkeletonLoader type="table" count={1} />
      ) : empty ? (
        <EmptyState
          icon={emptyIcon}
          title={emptyTitle}
          description={emptyDescription}
          actionLabel={emptyActionLabel}
          onAction={onEmptyAction}
          secondaryActionLabel={emptySecondaryActionLabel}
          onSecondaryAction={onEmptySecondaryAction}
        >
          {!emptyTitle && emptyText}
        </EmptyState>
      ) : (
        <PageSection>{children}</PageSection>
      )}
    </PageLayout>
  );
}
